import momentTz from 'moment-timezone';

export function formatDateLocal(date, format) {
  const localTz = momentTz.tz.guess();
  return momentTz.tz(date, localTz).format(format);
}
